// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_ExpenseConciliationUnlinkDespesaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for expense_conciliation_unlink_despesa /payroll/expense_conciliation_unlink_despesa
 * Returns success flag indicating whether the despesa was unlinked
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_ExpenseConciliationUnlinkDespesaResponseDados = boolean;

export type Payroll_ExpenseConciliationUnlinkDespesaResponse = ApiResponse<Payroll_ExpenseConciliationUnlinkDespesaResponseDados>;

registerResponseContract('Payroll_ExpenseConciliationUnlinkDespesaResponse', {})
